import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EmulateEmailPendingLinkClickResponse extends BackendResponse {}
export interface EmulateEmailPendingLinkClickParameters extends NextApiParams {}

export const emulateEmailPendingLinkClick = withNextApi<
  EmulateEmailPendingLinkClickResponse,
  EmulateEmailPendingLinkClickParameters
>("/cvp/CvpEmulateEmailPendingLinkClick");
